export default __webpack_public_path__ + "static/media/bsc.cb6b375e.jpg";